import { Reveal } from "../Reveal";
import { Chapter } from "../Chapter";

export const Children = () => (
  <section className="mx-auto max-w-6xl px-5 md:px-8 py-20 md:py-28" data-testid="children-section">
    <Chapter
      n={4}
      kicker="The long view"
      title="The relationship may end. The family doesn’t have to."
    />
    <div className="max-w-3xl">
      <Reveal>
        <p className="text-base md:text-lg leading-relaxed text-ink/70">
          When children are involved, the question isn’t only who’s right.
          It’s what kind of family you’re building from here.
        </p>
      </Reveal>
      <Reveal delay={0.12}>
        <p
          className="mt-10 font-serif text-2xl md:text-3xl tracking-tight leading-snug text-pine"
          data-testid="children-emphasis"
        >
          What do the kids need from you right now?
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <figure className="mt-14 overflow-hidden">
          <img
            src="/images/trainers-door.jpg"
            alt="Adult and children’s trainers by a slightly open door"
            loading="lazy"
            className="aspect-[3/2] w-full object-cover"
            data-testid="children-photo"
          />
        </figure>
      </Reveal>
    </div>
  </section>
);
